import React from 'react';

// Scènes SVG animées des shorts — la position des éléments dépend de la phase (0-3)
const Road = ({ children }) => (
  <svg viewBox="0 0 360 520" className="w-full h-full" preserveAspectRatio="xMidYMid slice">
    <rect width="360" height="520" fill="#15241a" />
    {children}
  </svg>
);

const Car = ({ x, y, rotate = 0, color = '#dc2626' }) => (
  <g style={{ transform: `translate(${x}px, ${y}px) rotate(${rotate}deg)`, transformOrigin: 'center', transition: 'transform 1.4s cubic-bezier(.4,0,.2,1)' }}>
    <rect x="-13" y="-24" width="26" height="48" rx="7" fill={color} stroke="#fff" strokeWidth="1.5" />
    <rect x="-9" y="-16" width="18" height="10" rx="2" fill="#1a1a1e" />
  </g>
);

function GiratoireScene({ phase }) {
  const angles = [150, 95, 20, -60];
  const a = (angles[phase] * Math.PI) / 180;
  const inRound = phase >= 1 && phase <= 2;
  const pos = phase === 0
    ? { x: 180, y: 430, r: 0 }
    : phase === 3
      ? { x: 310, y: 150, r: 35 }
      : { x: 180 + 95 * Math.cos(a), y: 240 - 95 * Math.sin(a), r: 90 - angles[phase] };
  return (
    <Road>
      <circle cx="180" cy="240" r="140" fill="#2a2d33" />
      <circle cx="180" cy="240" r="52" fill="#1d3324" stroke="#e8e8e8" strokeWidth="2.5" />
      <circle cx="180" cy="240" r="96" fill="none" stroke="#e8e8e8" strokeWidth="2" strokeDasharray="14 12" opacity="0.4" />
      <rect x="150" y="360" width="60" height="160" fill="#2a2d33" />
      <rect x="265" y="60" width="95" height="60" fill="#2a2d33" transform="rotate(32 265 60)" />
      <polygon points="150,372 162,372 156,384" fill="#fff" />
      <polygon points="170,372 182,372 176,384" fill="#fff" />
      <polygon points="190,372 202,372 196,384" fill="#fff" />
      <Car x={320} y={200} rotate={120} color="#5b7fd4" />
      <Car x={pos.x} y={pos.y} rotate={pos.r} />
      {phase >= 2 && (
        <circle cx={pos.x + 16} cy={pos.y + 14} r="5" fill="#fbbf24">
          <animate attributeName="opacity" values="1;0.1;1" dur="0.8s" repeatCount="indefinite" />
        </circle>
      )}
    </Road>
  );
}

function CrossScene({ phase, variant }) {
  const isStop = variant === 'stop';
  const isCedez = variant === 'cedez';
  const isPad = variant === 'pad';
  const isPrio = variant === 'prioritaire';
  const ys = isPrio ? [460, 350, 240, 150] : [460, 370, 300, 170];
  const y = ys[phase];
  const rival = isPad
    ? [420, 360, 240, -60][phase]
    : isPrio ? [420, 400, 390, 420][phase] : [420, 390, 330, 150][phase];
  return (
    <Road>
      <rect x="0" y="200" width="360" height="80" fill="#2a2d33" />
      <rect x="135" y="0" width="90" height="520" fill="#2a2d33" />
      <line x1="180" y1="290" x2="180" y2="520" stroke="#e8e8e8" strokeWidth="2" strokeDasharray="12 10" opacity="0.4" />
      {isStop && (
        <>
          <rect x="182" y="286" width="40" height="6" fill="#fff" />
          <text x="202" y="315" textAnchor="middle" fill="#fff" fontSize="12" fontWeight="900" letterSpacing="2">STOP</text>
          <g transform="translate(245, 268)">
            <line x1="0" y1="0" x2="0" y2="24" stroke="#888" strokeWidth="2.5" />
            <polygon points="0,-17 9,-14 12,-5 12,3 9,12 0,15 -9,12 -12,3 -12,-5 -9,-14" fill="#d22" stroke="#fff" strokeWidth="2" />
          </g>
        </>
      )}
      {isCedez && (
        <>
          {[0, 1, 2].map((i) => (
            <polygon key={i} points={`${186 + i * 13},288 ${194 + i * 13},288 ${190 + i * 13},299`} fill="#fff" />
          ))}
          <g transform="translate(245, 266)">
            <line x1="0" y1="0" x2="0" y2="26" stroke="#888" strokeWidth="2.5" />
            <polygon points="-13,-15 13,-15 0,6" fill="#fff" stroke="#d22" strokeWidth="3.5" />
          </g>
        </>
      )}
      {isPad && (
        <g transform="translate(248, 320)">
          <line x1="0" y1="0" x2="0" y2="24" stroke="#888" strokeWidth="2.5" />
          <polygon points="0,-20 17,8 -17,8" fill="#fff" stroke="#d22" strokeWidth="3.5" />
          <path d="M -6 -7 L 6 3 M 6 -7 L -6 3" stroke="#111" strokeWidth="2.5" strokeLinecap="round" />
        </g>
      )}
      {isPrio && (
        <>
          <line x1="0" y1="240" x2="128" y2="240" stroke="#e8e8e8" strokeWidth="2" strokeDasharray="14 12" opacity="0.5" />
          <line x1="232" y1="240" x2="360" y2="240" stroke="#e8e8e8" strokeWidth="2" strokeDasharray="14 12" opacity="0.5" />
          <g transform="translate(112, 330)">
            <line x1="0" y1="0" x2="0" y2="24" stroke="#888" strokeWidth="2.5" />
            <rect x="-12" y="-12" width="24" height="24" rx="2.5" fill="#fff" transform="rotate(45)" />
            <rect x="-6.5" y="-6.5" width="13" height="13" rx="1.5" fill="#f5c518" transform="rotate(45)" />
            {phase === 3 && <line x1="-13" y1="13" x2="13" y2="-13" stroke="#d22" strokeWidth="3.5" strokeLinecap="round" />}
          </g>
        </>
      )}
      {/* véhicule transversal */}
      <g style={{ transform: `translate(${rival}px, 222px)`, transition: 'transform 1.4s ease' }} opacity={isPrio && phase >= 1 ? 0.9 : 1}>
        <rect x="0" y="0" width="46" height="26" rx="6" fill="#5b7fd4" stroke="#fff" strokeWidth="1.5" />
      </g>
      <Car x={180} y={y} />
      {/* badge vitesse */}
      <g transform="translate(16, 492)">
        <rect x="0" y="-18" width="92" height="28" rx="8" fill="#000" opacity="0.6" />
        <text x="46" y="1" textAnchor="middle" fill="#fbbf24" fontSize="12" fontWeight="900" fontFamily="monospace">
          {isStop ? ['~40 km/h', '~20 km/h', '0 km/h ✓', '1ère →'][phase]
            : isCedez ? ['~40 km/h', '~28 km/h', '~22 km/h', 'On roule'][phase]
            : isPad ? ['~45 km/h', '~35 km/h', 'ON CÈDE', '~30 km/h'][phase]
            : ['70 km/h', '70 · regard', '70 km/h', 'FIN AB6b'][phase]}
        </text>
      </g>
    </Road>
  );
}

export default function ShortScene({ scene, phase }) {
  if (scene === 'giratoire') return <GiratoireScene phase={phase} />;
  return <CrossScene phase={phase} variant={scene} />;
}
